import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useStore } from '../../store/store';
import { NavbarListButton } from '../Layout/NavbarListButton';
import { NavbarButton } from '../Layout/NavbarButton';
import FontSizeButton from './FontSizeButton';
import { FONT_SIZES } from '../../constants/constants';
import { iconButtonStyle } from '../../utils/styles';

const selector = ({ configuration }) => ({
  configuration,
});

const FontSizeControl = (props) => {
  const { configuration } = useStore(selector);
  var currentStyle = props?.editorState?.getCurrentInlineStyle(props.editorState.getSelection());

  // Chercher la taille de police appliquée
  let currentFontSize = props.defaultFontSize;
  props.fontSizes.forEach((type) => {
    if (currentStyle?.has(`FONT_SIZE_${type.value}`)) {
      currentFontSize = type.value;
    }
  });

  const { t } = useTranslation();

  // Créer les options de taille de police
  const fontSizeOptions = FONT_SIZES.filter((fs) => fs.display);

  return (
    <div
      id="font-size-control"
      style={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <NavbarButton
        tooltipContent={t('decrease-font-size')}
        buttonStyle={{
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderRight: 0,
          marginRight: 0,
        }}
        icon={
          <FontAwesomeIcon
            icon={icon({ name: 'minus' })}
            style={{ fontSize: 16 }}
          />}
        onClick={() => {
          if (Number(currentFontSize) > FONT_SIZES[0].value) {
            props.onToggle(currentFontSize - 1);
          }
        }}
      />
      <NavbarListButton
        title={t('font-size')}
        disabled={false}
        icon={
          <span style={{ fontSize: '15px', fontFamily: 'monospace' }}>
            {currentFontSize}
          </span>
        }
        onListElementClick={props.onToggle}
        isOpen={props.isOpen}
        onToggleOpen={props.onToggleOpen}
        customStyle={{
          borderRadius: 0,
          width: 50,
          margin: 0,
        }}
      >
        {fontSizeOptions.map((option, index) => (
          <FontSizeButton
            key={option.value}
            active={option.value === currentFontSize}
            label={option.label}
            onToggle={props.onToggle}
            fontSize={option.value}
            positionStyle={{
              gridColumn: Math.ceil((index + 1) / 5),
              gridRow: (index % 5) + 1,
            }}
            size='32px'
          />
        ))}
      </NavbarListButton>
      <NavbarButton
        tooltipContent={t('increase-font-size')}
        buttonStyle={{
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          borderLeft: 0,
        }}
        icon={
          <FontAwesomeIcon
            icon={icon({ name: 'plus' })}
            style={{ fontSize: 16 }}
          />
        }
        onClick={() => {
          if (Number(currentFontSize) < FONT_SIZES[FONT_SIZES.length - 1].value) {
            props.onToggle((currentFontSize) + 1);
          }
        }}
      />
    </div>
  );
};

export default FontSizeControl;
